import fetchClient from '@/api/api-client'

export const getAndIncreaseXLT = async () => {
  try {
    const result = await fetchClient.get(`/xltNumber/qGetAndIncrease`)
    // console.log("getAndIncreaseXLT - result:", result.data.data.response)
    return result.data.data.response
  } catch (error) {
    throw error
  }
}

// export async function releaseXlt(xltId) {
//   try {
//     const res = await fetchClient.get(`/xltNumber/release/${xltId}`)
//     //const res = await axios.get(`${BASEURL}/xltNumber/release/${xltId}`)
//     return res.data
//   } catch (err) {
//     console.log('Error in listUsers:' + err)
//     throw err
//   }
// }
